export const GET_LOCK_DATA  = 'GET_LOCK_DATA';
export const LOCK_DATA_REQUEST  = 'LOCK_DATA_REQUEST';
export const SET_LOCK_DATA  = 'SET_LOCK_DATA';
export const LOCK_DATA_REQUEST_FAILURE  = 'LOCK_DATA_REQUEST_FAILURE';